/**
 * @generated SignedSource<<be045ad908a7b78e99247f27fb36f2e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type MilestoneRow$data = {
  readonly closed: boolean;
  readonly description: string | null | undefined;
  readonly dueOn: string | null | undefined;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"MilestoneIssueCount" | "MilestoneRowMetadata" | "MilestoneRowTitle">;
  readonly " $fragmentType": "MilestoneRow";
};
export type MilestoneRow$key = {
  readonly " $data"?: MilestoneRow$data;
  readonly " $fragmentSpreads": FragmentRefs<"MilestoneRow">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MilestoneRow",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "closed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dueOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MilestoneRowTitle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MilestoneRowMetadata"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MilestoneIssueCount"
    }
  ],
  "type": "Milestone",
  "abstractKey": null
};

(node as any).hash = "c3e688dddca33bb469acc4d4c4853e1c";

export default node;
